import { render, staticRenderFns } from "./budgetUploads.vue?vue&type=template&id=36c417f0&scoped=true"
import script from "./budgetUploads.vue?vue&type=script&lang=ts"
export * from "./budgetUploads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c417f0",
  null
  
)

export default component.exports